import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.59.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9.1_@playwrig_5c4777978b8dbb2d66999c9adea9ee26/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingMobileMenu"] */ "/app/packages/frontend/components/landing/LandingMobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNavAuthCta"] */ "/app/packages/frontend/components/landing/LandingNavAuthCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/packages/frontend/components/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuContent","DropdownMenuItem"] */ "/app/packages/frontend/components/ui/dropdown-menu.tsx");
